







import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const allCustomerReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.ALL_CUSTOMERS_ACCOUTNANT:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ALL_CUSTOMERS_ACCOUTNANT_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ALL_CUSTOMERS_ACCOUTNANT_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
